var _rect, _text, _path, _path2, _rect2, _circle, _text2, _text3, _text4, _rect3, _circle2, _text5, _text6, _text7, _rect4, _circle3, _text8, _text9, _text0, _rect5, _circle4, _text1, _text10, _text11, _rect6, _circle5, _text12, _text13, _text14, _g, _rect7, _circle6, _text15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentDeliveryProcessPathwayDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 450,
    viewBox: "0 0 720 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom system delivery pathway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 448,
    rx: 27,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 42,
    fill: "#74BDFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "DELIVERY PATHWAY"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 276H648",
    stroke: "#2D608D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M642 270l9 6-9 6",
    fill: "none",
    stroke: "#74BDFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 75,
    width: 124,
    height: 150,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 102,
    r: 13,
    fill: "#74BDFF",
    fillOpacity: 0.14,
    stroke: "#74BDFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 106,
    textAnchor: "middle",
    fill: "#74BDFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 106,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Discover")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 137,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 0
  }, "Problem"), /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 16
  }, "Process"), /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 16
  }, "Data"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 75,
    width: 124,
    height: 150,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 102,
    r: 13,
    fill: "#FF2775",
    fillOpacity: 0.14,
    stroke: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 187,
    y: 106,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 209,
    y: 106,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Design")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 137,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 178,
    dy: 0
  }, "Architecture"), /*#__PURE__*/React.createElement("tspan", {
    x: 178,
    dy: 16
  }, "Controls"), /*#__PURE__*/React.createElement("tspan", {
    x: 178,
    dy: 16
  }, "Experience"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 75,
    width: 124,
    height: 150,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 102,
    r: 13,
    fill: "#F4B63D",
    fillOpacity: 0.14,
    stroke: "#F4B63D"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 106,
    textAnchor: "middle",
    fill: "#F4B63D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 346,
    y: 106,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Prototype")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 137,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 315,
    dy: 0
  }, "Workflow"), /*#__PURE__*/React.createElement("tspan", {
    x: 315,
    dy: 16
  }, "Feedback"), /*#__PURE__*/React.createElement("tspan", {
    x: 315,
    dy: 16
  }, "Validation"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 75,
    width: 124,
    height: 150,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 102,
    r: 13,
    fill: "#30D6A1",
    fillOpacity: 0.14,
    stroke: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 461,
    y: 106,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 483,
    y: 106,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Build")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 137,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 452,
    dy: 0
  }, "Engineering"), /*#__PURE__*/React.createElement("tspan", {
    x: 452,
    dy: 16
  }, "Integration"), /*#__PURE__*/React.createElement("tspan", {
    x: 452,
    dy: 16
  }, "Testing"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 75,
    width: 124,
    height: 150,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 102,
    r: 13,
    fill: "#087CFF",
    fillOpacity: 0.14,
    stroke: "#087CFF"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 598,
    y: 106,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "05")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 106,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Optimise")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 589,
    y: 137,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 589,
    dy: 0
  }, "Adoption"), /*#__PURE__*/React.createElement("tspan", {
    x: 589,
    dy: 16
  }, "Measure"), /*#__PURE__*/React.createElement("tspan", {
    x: 589,
    dy: 16
  }, "Refine"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#74BDFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 276,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 276,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 276,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497,
    cy: 276,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 276,
    r: 6
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 326,
    width: 652,
    height: 82,
    rx: 17,
    fill: "#10243E",
    stroke: "#294766"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 367,
    r: 6,
    fill: "#30D6A1"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 83,
    y: 358,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 83,
    dy: 0
  }, "DECISION POINT AT EVERY STAGE"), /*#__PURE__*/React.createElement("tspan", {
    x: 83,
    dy: 20
  }, "Scope, evidence and acceptance criteria are agreed before the next commitment."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentDeliveryProcessPathwayDesktop);
export default __webpack_public_path__ + "static/media/custom-development-delivery-process-pathway-desktop.620dc5b30a0017cacccfb48ca66cea06.svg";
export { ForwardRef as ReactComponent };